import { render, staticRenderFns } from "./icare_join_detail.vue?vue&type=template&id=422dec86&scoped=true&"
import script from "./icare_join_detail.vue?vue&type=script&lang=js&"
export * from "./icare_join_detail.vue?vue&type=script&lang=js&"
import style0 from "./icare_join_detail.vue?vue&type=style&index=0&id=422dec86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422dec86",
  null
  
)

export default component.exports